import React, { useEffect } from 'react';

const AdComponent = ({ adId, containerId }) => {
  useEffect(() => {
    const loadAdScript = () => {
      if (!document.querySelector('script[src="//cpro.baidustatic.com/cpro/ui/cm.js"]')) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//cpro.baidustatic.com/cpro/ui/cm.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }
    };

    const initAd = () => {
      window.slotbydup = window.slotbydup || [];
      window.slotbydup.push({
        id: adId,
        container: containerId,
        async: true
      });
    };

    loadAdScript();
    initAd();
  }, [adId, containerId]);

  return (
    <div className={containerId}></div>
  );
};

export default AdComponent;